"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * @file Created on Wed Jun 05 2019
 */

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * @author BPo
 */


var WindowPerformanceReportRowDTOConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(WindowPerformanceReportRowDTOConverter, _DataObjectConverter_);

  function WindowPerformanceReportRowDTOConverter() {
    _classCallCheck(this, WindowPerformanceReportRowDTOConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(WindowPerformanceReportRowDTOConverter).apply(this, arguments));
  }

  return WindowPerformanceReportRowDTOConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.WindowPerformanceReportRowDTOConverter = WindowPerformanceReportRowDTOConverter;